<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES35UC4']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="detail-block-float detail-block-left">
                <div class="detail-header">{{ labels['HRES35UC3']['20'] }}</div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES35UC3']['40'] }}</div>
                  <div class="detail-right">
                    <div class="detail-text width-100"> 
                      {{ detail.tab1.codcomp1 }}-{{ detail.tab1.codcomp2 }}-{{ detail.tab1.codcomp3 }}-{{ detail.tab1.codcomp4 }}-{{ detail.tab1.codcomp5 }}-{{ detail.tab1.codcomp6 }}-{{ detail.tab1.codcomp7 }}
                    </div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left"></div>
                  <div class="detail-right">
                      <div class="detail-text width-100">{{ detail.tab1.desc_codcomp }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES35UC3']['50'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100">{{ detail.tab1.desc_codpos }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES35UC3']['60'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100">{{ detail.tab1.desc_codjob }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES35UC3']['70'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100">{{ detail.tab1.desc_codbrlc }}</div>
                  </div>
                </div>
              </div>

              <div class="detail-block-float detail-block-right">
                <div class="detail-header">{{ labels['HRES35UC3']['30'] }}</div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES35UC3']['40'] }}</div>
                  <div class="detail-right">
                    <div class="detail-text width-100" :class="{ 'text-red' : ( detail.tab1.codcomp1 != detail.tab1.codcom1 || 
                                                                  detail.tab1.codcomp2 != detail.tab1.codcom2 || 
                                                                  detail.tab1.codcomp3 != detail.tab1.codcom3 || 
                                                                  detail.tab1.codcomp4 != detail.tab1.codcom4 || 
                                                                  detail.tab1.codcomp5 != detail.tab1.codcom5 || 
                                                                  detail.tab1.codcomp6 != detail.tab1.codcom6 || 
                                                                  detail.tab1.codcomp7 != detail.tab1.codcom7 ) }" >
                      {{ detail.tab1.codcom1 }}-{{ detail.tab1.codcom2 }}-{{ detail.tab1.codcom3 }}-{{ detail.tab1.codcom4 }}-{{ detail.tab1.codcom5 }}-{{ detail.tab1.codcom6 }}-{{ detail.tab1.codcom7 }}
                    </div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left"></div>
                  <div class="detail-right">
                      <div class="detail-text width-100" :class="{ 'text-red' : detail.tab1.desc_codcomp != detail.tab1.desc_codcomp2 }">{{ detail.tab1.desc_codcomp2 }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES35UC3']['50'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" :class="{ 'text-red' : detail.tab1.desc_codpos != detail.tab1.desc_codpos2 }">{{ detail.tab1.desc_codpos2 }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES35UC3']['60'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" :class="{ 'text-red' : detail.tab1.desc_codjob != detail.tab1.desc_codjob2 }">{{ detail.tab1.desc_codjob2 }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES35UC3']['70'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" :class="{ 'text-red' : detail.tab1.desc_codbrlc != detail.tab1.desc_codbrlc2 }">{{ detail.tab1.desc_codbrlc2 }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="box-footer">
            <div class="detail detail-responsive">
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES35UC3']['80'] }}</div>
                <div class="detail-right">
                    <div class="detail-text width-70">{{ detail.tab1.descreq1 }}</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
export default {
  name: 'hres35u-detail',
  props: [ 'labels', 'detail', 'toggle', 'data', 'nowLang', 'labelsButton' ]
}
</script>



// WEBPACK FOOTER //
// detail.vue?287a8102